import { ReactNode } from "react";
import { IconInfoCircle } from "@tabler/icons-react";
import { Button } from "@altimateai/lego";

import classes from "./chart.module.scss";

// Legend label, optionally followed by an info icon whose tooltip explains the
// series. Plugged into Chart via the `legendProps.formatter` hook. Defaults to
// the chart legend styling so it matches Chart's built-in legend rendering.
// The `Button`'s `title` renders the tooltip; `size="icon"` is shrunk to sit
// inline with the legend text.
export const ChartLegendItem = ({
  label,
  tooltip,
  dimmed,
  className = classes.legend,
}: {
  label: ReactNode;
  tooltip?: string;
  /** Renders this entry's colour swatch at the same reduced opacity its marks
   *  use, for a series drawn lighter than its palette colour (a projection
   *  against its actual). Recharts' legend payload carries only `fill`, never
   *  the mark's `fillOpacity`, so without this the two entries of an
   *  actual/projected pair get identical swatches. */
  dimmed?: boolean;
  className?: string;
}) => (
  <span className={className} data-legend-dimmed={dimmed ? "true" : undefined}>
    {label}
    {tooltip ? (
      <Button
        variant="ghost"
        size="icon"
        title={tooltip}
        aria-label="Cost attribution info"
        // Clicking the icon must not toggle the series this legend item controls.
        onClick={e => e.stopPropagation()}
        className="al-ml-1 al-inline-flex al-h-auto al-w-auto al-cursor-help al-p-0 al-align-middle al-text-muted-foreground"
      >
        <IconInfoCircle size={14} aria-hidden />
      </Button>
    ) : null}
  </span>
);
